import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Container from '../Container/Container';
import { get, ImageUrl, postFormData } from '../ApiServices/ApiServices';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from './Component/Loader';
import { useRef } from 'react';
import DeleteButton from './Component/DeleteFun';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { Image } from 'antd';

function Inventory() {
	const [tab, setTab] = useState(1);
	const [inventory, setInventory] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [totalItems, setTotalItems] = useState(0);
	const [searchQuery, setSearchQuery] = useState('');
	const [selectedImage, setSelectedImage] = useState(null);
	const [filterStatus, setFilterStatus] = useState("")
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [Pant, setPant] = useState([])
	const [type, settype] = useState("")
	const [id, setid] = useState(null)
	const ref1 = useRef()
	const fileInputRef = useRef(null);
	const shirtTypes = ["Standard length", "Added length", "Fitted"];
	const vestTypes = ["Standard Vest", "Tweed Vest"];
	// Define belt color options
	const beltColors = [
		{ value: 'Brown', label: 'Brown' },
		{ value: 'Cognac', label: 'Cognac' },
		{ value: 'White', label: 'White' },
		{ value: 'Black', label: 'Black' },
	];

	const profile = useSelector((state) => state.profile.profile);
	const isAdmin = profile?.name === "Admin";

	const handleModalOpen = () => {
		if (fileInputRef.current) {
			fileInputRef.current.value = '';
		}
	};

	const handleModalClose = () => {
		if (fileInputRef.current) {
			fileInputRef.current.value = '';
		}
	};

	const navigate = useNavigate()

	// Updated validation schema
	const validationSchema = Yup.object({
		style: Yup.string().required('Style is required'),
		description: Yup.string().required('Description is required'),
		coatColor: tab === 1 ? Yup.string().required('Coat color is required') : Yup.string().notRequired(),
		matchingPantStyle: Yup.string().notRequired(),
		// beltColor: tab === 2 ? Yup.string().required('Belt color is required') : Yup.string().notRequired(),
		beltColor: tab === 2 && Yup.string().notRequired(),
		shoeColor: tab === 7 ? Yup.string().required('Shoe color is required') : Yup.string().notRequired(),
		shirtType: tab === 3
			? Yup.string().required('Shirt type is required')
			: Yup.string().notRequired(),

		vestType: tab === 4
			? Yup.string().required('Vest type is required')
			: Yup.string().notRequired(),
	});



	const formik = useFormik({
		initialValues: {
			style: '',
			active: true,
			description: '',
			coatImage: null,
			beltColor: beltColors[0]?.value || '',
			shoeColor: '',
			coatColor: '',
			matchingPantStyle: '',
			// shirtType: 'Standard length',
			shirtType: shirtTypes[0] || '',

			vestType: '',
		},
		validationSchema,
		onSubmit: async (values, { setSubmitting, resetForm }) => {
			try {
				console.log('Form submitted for tab:', tab);
				console.log('Type:', type);
				console.log('Values:', values, "values.beltColor", values.beltColor);
				setIsSubmitting(true)
				const formData = new FormData();
				formData.append('active', values.active);
				formData.append('description', values.description);
				formData.append('style', values?.style);

				// Only append image if it exists
				if (values.coatImage) {
					formData.append('image', values.coatImage || null);
				}


				// Tab-specific fields
				if (tab === 1) { // Coats
					formData.append('coat_color', values.coatColor);
					if (values.matchingPantStyle) {
						formData.append('match_pant_style', values.matchingPantStyle);
					}
				} else if (tab === 2) { // Pants
					formData.append('belt', values.beltColor);
				} else if (tab === 7) { // Shoes
					formData.append('shoe_color', values.shoeColor);
				}
				if (tab === 3) { // ✅ For Shirts
					formData.append('type', values.shirtType);
				}
				if (tab === 4) { // ✅ For vest
					formData.append('type', values.vestType);
				}

				if (type == "Add") {
					formData.append('category_id', tab);
				}

				const api = type == "Add" ? "create-inventory" : `edit-inventory/${id}`;
				const totalData = await postFormData(api, formData);

				setSelectedImage(null)
				handleModalClose()
				toast.success(totalData?.message, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					closeButton: false,
				});
				ref1.current.click()

				resetForm();
				fetchInventoryData();
			} catch (error) {
				toast.error(error.message || 'Failed to submit form. Please try again.', {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					closeButton: false,
				});
			} finally {
				setIsSubmitting(false);
			}
		},
	});

	console.log("Initial Formik Values:", formik.initialValues);
	// Reset form when tab changes
	useEffect(() => {
		formik.resetForm();
		setSelectedImage(null);
	}, [tab]);

	const fetchInventoryData = async () => {
		try {
			setIsLoading(true);
			const api = `all-inventories?category_id=${tab}&page_number=${currentPage}&size=${itemsPerPage}&search=${searchQuery}&active=${filterStatus}&orderby=asc&sortby=style`;
			const totalData = await get(api);
			setInventory(totalData?.data?.rows);
			setTotalItems(totalData?.data?.count);
		} catch (err) {
			if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
				localStorage.removeItem('token');
				navigate('/login');
			}
			console.error('Error fetching inventory data:', err);
		} finally {
			setIsLoading(false);
		}
	};

	const fetchpantInventoryData = async () => {
		try {
			const api = `all-inventories?category_id=${2}&size=${1000}&active=${true}&orderby=asc&sortby=style`;
			const totalData = await get(api);
			setPant(totalData?.data?.rows)
		} catch (err) {
			console.error('Error fetching inventory data:', err);
		}
	};

	useEffect(() => {
		fetchpantInventoryData()
	}, [])

	useEffect(() => {
		fetchInventoryData();
	}, [tab, currentPage, itemsPerPage, searchQuery, filterStatus]);

	const handlePageChange = (page) => {
		setCurrentPage(page);
	};

	const handleItemsPerPageChange = (event) => {
		setItemsPerPage(Number(event.target.value));
		setCurrentPage(1);
	};

	const handleSearchChange = (event) => {
		setSearchQuery(event.target.value);
		setCurrentPage(1);
	};

	const GetSingleInventory = async (id) => {
		try {
			setid(id)
			settype("Edit")
			const api = `view-inventory/${id}`;
			const totalData = await get(api);
			console.log("Formik values after setValues:", totalData);

			setSelectedImage(totalData?.data?.image ? `${ImageUrl}${totalData?.data?.image}` : "assets/images/no-photo.png")
			const shirtTypeValue = shirtTypes.includes(totalData?.data?.type)
				? totalData.data.type
				: shirtTypes[0] || 'Standard length';
			const vestTypesValue = vestTypes.includes(totalData?.data?.type)
				? totalData.data.type
				: vestTypes[0] || ' ';
			formik.setValues({
				style: totalData?.data?.style,
				active: totalData?.data?.active,
				description: totalData?.data?.description,
				coatImage: totalData?.data?.image,
				beltColor: totalData?.data?.belt || '',
				shoeColor: totalData?.data?.shoe_color || '',
				coatColor: totalData?.data?.coat_color || '',
				matchingPantStyle: totalData?.data?.match_pant_style || null,
				// shirtType: totalData?.data?.type || "Standard length", // ✅ Add this
				shirtType: shirtTypeValue,
				// vestTypes: totalData?.data?.type || '',
				vestType: vestTypesValue,

			})
		}
		catch (err) {
			console.error(err);
		}
	}

	const getTableColumns = () => {
		switch (tab) {
			case 1:
				return [
					{ header: 'Style', accessor: 'style' },
					{ header: 'Description', accessor: 'description' },
					{
						header: 'Image', accessor: 'image',
						render: (item) => (
							<Image
								width={50}
								src={item?.image ? `${ImageUrl}${item.image}` : "assets/images/no-photo.png"}
								className="imgCoatTable"
								alt=""
								fallback="assets/images/no-photo.png"
							/>
						)
					},
					{ header: 'Color', accessor: 'coatColor', render: (item) => item?.coat_color || 'N/A' },
					{ header: 'Matching Pant', accessor: 'matchingPant', render: (item) => item?.match_pant_style || 'N/A' },
					profile?.name == "Admin" && { header: 'Active', accessor: 'active', render: (item) => (item?.active == true ? "YES" : "NO") },
					profile?.name == "Admin" &&
					{
						header: 'Edit Coat',
						accessor: 'edit',
						render: (item) =>
							<>
								<button
									data-bs-toggle="modal"
									data-bs-target="#addCoatModal"
									className="editPen"
									onClick={() => GetSingleInventory(item?.id)}
								>
									<em className="icon ni ni-edit-alt"></em>
								</button> <DeleteButton
									url={`delete-inventory/${item?.id}`}
									onDeleteSuccess={handleDeleteSuccess}
								/>
							</>
					}];
			case 2:
				return [
					{ header: 'Style', accessor: 'style' },
					{ header: 'Description', accessor: 'description' },
					{ header: 'Belt Color', accessor: 'beltColor', render: (item) => item?.belt || 'N/A' },
					{
						header: 'Image',
						accessor: 'image',
						render: (item) => (
							<Image
								width={50}
								src={item?.image ? `${ImageUrl}${item.image}` : "assets/images/no-photo.png"}
								className="imgCoatTable"
								alt=""
								fallback="assets/images/no-photo.png"
							/>
						)
					},
					profile?.name == "Admin" && { header: 'Active', accessor: 'active', render: (item) => (item?.active == true ? "YES" : "NO") },
					profile?.name == "Admin" && {
						header: 'Edit Pant', accessor: 'edit', render: (item) => <> <a href="" data-bs-toggle="modal" data-bs-target="#addCoatModal" className="editPen" onClick={() => { GetSingleInventory(item?.id) }}><em className="icon ni ni-edit-alt"></em></a>	<DeleteButton
							url={`delete-inventory/${item?.id}`}
							onDeleteSuccess={handleDeleteSuccess}
						/></>
					},
				];
			case 3:
				return [
					{ header: 'Style', accessor: 'style' },
					{ header: 'Description', accessor: 'description' },
					{ header: 'Type', accessor: 'type', render: (item) => item?.type || "Standard length" },
					{
						header: 'Image',
						accessor: 'image',
						render: (item) => (
							<Image
								width={50}
								src={item?.image ? `${ImageUrl}${item.image}` : "assets/images/no-photo.png"}
								className="imgCoatTable"
								alt=""
								fallback="assets/images/no-photo.png"
							/>
						)
					},
					profile?.name == "Admin" && { header: 'Active', accessor: 'active', render: (item) => (item?.active == true ? "YES" : "NO") },
					profile?.name == "Admin" && {
						header: 'Edit Shirt', accessor: 'edit', render: (item) => <> <a href="" data-bs-toggle="modal" data-bs-target="#addCoatModal" className="editPen" onClick={() => { GetSingleInventory(item?.id) }}><em className="icon ni ni-edit-alt"></em></a> <DeleteButton
							url={`delete-inventory/${item?.id}`}
							onDeleteSuccess={handleDeleteSuccess}
						/></>
					},
				];
			case 4:
				return [
					{ header: 'Style', accessor: 'style', render: (item) => `${item?.style}` },
					{ header: 'Description', accessor: 'description' },
					{ header: 'Type', accessor: 'type', render: (item) => item?.type || "Standard Vest" },
					{
						header: 'Image',
						accessor: 'image',
						render: (item) => (
							<Image
								width={50}
								src={item?.image ? `${ImageUrl}${item.image}` : "assets/images/no-photo.png"}
								className="imgCoatTable"
								alt=""
								fallback="assets/images/no-photo.png"
							/>
						)
					},
					profile?.name == "Admin" && { header: 'Active', accessor: 'active', render: (item) => (item?.active == true ? "YES" : "NO") },
					profile?.name == "Admin" && {
						header: 'Edit Vest', accessor: 'edit', render: (item) => <><a href="" data-bs-toggle="modal" data-bs-target="#addCoatModal" className="editPen" onClick={() => { GetSingleInventory(item?.id) }}><em className="icon ni ni-edit-alt"></em></a> <DeleteButton
							url={`delete-inventory/${item?.id}`}
							onDeleteSuccess={handleDeleteSuccess}
						/>
						</>
					},
				];
			case 5:
				return [
					{ header: 'Style', accessor: 'style' },
					{ header: 'Description', accessor: 'description' },
					{
						header: 'Image',
						accessor: 'image',
						render: (item) => (
							<Image
								width={50}
								src={item?.image ? `${ImageUrl}${item.image}` : "assets/images/no-photo.png"}
								className="imgCoatTable"
								alt=""
								fallback="assets/images/no-photo.png"
							/>
						)
					},
					profile?.name == "Admin" && { header: 'Active', accessor: 'active', render: (item) => (item?.active == true ? "YES" : "NO") },
					profile?.name == "Admin" && {
						header: 'Edit Tie', accessor: 'edit', render: (item) => <> <a href="" data-bs-toggle="modal" data-bs-target="#addCoatModal" className="editPen" onClick={() => { GetSingleInventory(item?.id) }}><em className="icon ni ni-edit-alt"></em></a> <DeleteButton
							url={`delete-inventory/${item?.id}`}
							onDeleteSuccess={handleDeleteSuccess}
						/></>
					},
				];
			case 7:
				return [
					{ header: 'Style', accessor: 'style' },
					{ header: 'Description', accessor: 'description' },
					{ header: 'Shoe Color', accessor: 'shoecolor', render: (item) => item?.shoe_color || 'N/A' },
					{
						header: 'Image',
						accessor: 'image',
						render: (item) => (
							<Image
								width={50}
								src={item?.image ? `${ImageUrl}${item.image}` : "assets/images/no-photo.png"}
								className="imgCoatTable"
								alt=""
								fallback="assets/images/no-photo.png"
							/>
						)
					},
					profile?.name == "Admin" && { header: 'Active', accessor: 'active', render: (item) => (item?.active == true ? "YES" : "NO") },
					profile?.name == "Admin" && {
						header: 'Edit Shoe', accessor: 'edit', render: (item) => <><a href="" data-bs-toggle="modal" data-bs-target="#addCoatModal" className="editPen" onClick={() => { GetSingleInventory(item?.id) }}><em className="icon ni ni-edit-alt"></em></a> <DeleteButton
							url={`delete-inventory/${item?.id}`}
							onDeleteSuccess={handleDeleteSuccess}
						/></>
					},
				];
			case 8:
				return [
					{ header: 'Style', accessor: 'style' },
					{ header: 'Description', accessor: 'description' },
					{
						header: 'Image',
						accessor: 'image',
						render: (item) => (
							<Image
								width={50}
								src={item?.image ? `${ImageUrl}${item.image}` : "assets/images/no-photo.png"}
								className="imgCoatTable"
								alt=""
								fallback="assets/images/no-photo.png"
							/>
						)
					},
					profile?.name == "Admin" && { header: 'Active', accessor: 'active', render: (item) => (item?.active == true ? "YES" : "NO") },
					profile?.name == "Admin" && {
						header: 'Edit Pocket Square', accessor: 'edit', render: (item) => <><a href="" data-bs-toggle="modal" data-bs-target="#addCoatModal" className="editPen" onClick={() => { GetSingleInventory(item?.id) }}><em className="icon ni ni-edit-alt"></em></a> <DeleteButton
							url={`delete-inventory/${item?.id}`}
							onDeleteSuccess={handleDeleteSuccess}
						/></>
					},
				];
			case 9:
				return [
					{ header: 'Style', accessor: 'style' },
					{ header: 'Description', accessor: 'description' },
					{
						header: 'Image',
						accessor: 'image',
						render: (item) => (
							<Image
								width={50}
								src={item?.image ? `${ImageUrl}${item.image}` : "assets/images/no-photo.png"}
								className="imgCoatTable"
								alt=""
								fallback="assets/images/no-photo.png"
							/>
						)
					},
					profile?.name == "Admin" && { header: 'Active', accessor: 'active', render: (item) => (item?.active == true ? "YES" : "NO") },
					profile?.name == "Admin" && {
						header: 'Edit Jewelry ', accessor: 'edit', render: (item) => <><a href="" data-bs-toggle="modal" data-bs-target="#addCoatModal" className="editPen" onClick={() => { GetSingleInventory(item?.id) }}><em className="icon ni ni-edit-alt"></em></a> <DeleteButton
							url={`delete-inventory/${item?.id}`}
							onDeleteSuccess={handleDeleteSuccess}
						/></>
					},
				];
			default:
				return [];
		}
	};

	const renderTable = () => {
		const columns = getTableColumns();

		return (
			<div className="table-responsive">
				<table className="table table-striped">
					<thead>
						<tr>
							{columns.map((column, index) => (
								<th key={index} scope="col">{column.header}</th>
							))}
						</tr>
					</thead>
					<tbody>
						{
							isLoading ? <tr>
								<td colSpan="6" className="text-center">
									<div className="data-not-found">
										<Loader />
									</div>
								</td>
							</tr> :
								inventory.length > 0 ? inventory.map((item, index) => (
									<tr key={index}>
										{columns.map((column, colIndex) => (
											<td key={colIndex}>
												{column.render ? column.render(item) : item[column.accessor]}
											</td>
										))}
									</tr>
								))
									: <tr>
										<td colSpan="6" className="text-center">
											<div className="data-not-found">
												<em className="icon ni ni-info"></em>
												<p>No data available</p>
											</div>
										</td>
									</tr>

						}
					</tbody>
				</table>
			</div>
		);
	};

	const handleDeleteSuccess = () => {
		fetchInventoryData();
	};

	return (
		<Container>
			<div className="nk-content">
				<div className="container-fluid">
					<div className="nk-content-inner">
						<div className="nk-content-body">
							<div className="nk-block-head nk-block-head-sm pbZeroHeadin">
								<div className="nk-block-between">
									<div className="nk-block-head-content">
										<h3 className="nk-block-title page-title">Inventory</h3>
									</div>
								</div>
							</div>

							<div className="card card-full WeddingPagesMain">
								<div className="card-inner">


									<div className="row">
										<div className="col-md-3">
											<div className="form-control-wrap customrSearch mb-2">
												<div className="form-icon form-icon-right topZero">
													<em className="icon ni ni-search"></em>
												</div>
												<input
													type="text"
													className="form-control pr25"
													id="default-04"
													placeholder="Search by keywords"
													value={searchQuery}
													onChange={handleSearchChange}
												/>
											</div>
										</div>
										<div className="col-md-3">
											<div className="form-control-wrap mb-2">
												<div className="form-icon form-icon-right">
												</div>
												<select className="form-control pr25" onChange={(e) => setFilterStatus(e.target.value)} >
													<option value="">Filter by Active Status</option>
													<option value="">All</option>
													<option value="true">Yes</option>
													<option value="false">No</option>
												</select>
											</div>
										</div>
									</div>



								</div>
							</div>

							<div className="card card-preview">
								<div className="card-inner">
									<div className="inventoryResponsiveTab">
										<div className="mResponsive">
											<ul className="nav nav-tabs mt-n3">
												{[1, 2, 3, 4, 5, 7, 8, 9].map((tabNumber) => (
													<li key={tabNumber} className="nav-item" onClick={() => { setTab(tabNumber); setCurrentPage(1) }}>
														<a className={`nav-link ${tab === tabNumber ? 'active' : ''}`} data-bs-toggle="tab" href={`#tabItem${tabNumber}`}>
															{tabNumber === 1 ? 'Coats' : tabNumber === 2 ? 'Pants' : tabNumber === 3 ? 'Shirts' : tabNumber === 4 ? 'Vests' : tabNumber === 5 ? 'Ties' : tabNumber === 7 ? 'Shoes' : tabNumber === 8 ? 'Pocket Squares' : 'Jewelry '}
														</a>
													</li>
												))}
											</ul>
										</div>

										<div className="tab-content">
											{[1, 2, 3, 4, 5, 7, 8, 9].map((tabNumber) => (
												<div key={tabNumber} className={`tab-pane ${tab === tabNumber ? 'active' : ''}`} id={`tabItem${tabNumber}`}>
													<div className="nk-block-head nk-block-head-sm">
														<div className="nk-block-between">
															<div className="nk-block-head-content">
																<h5 className="nk-block-title">
																	{tabNumber === 1 ? 'Coats' : tabNumber === 2 ? 'Pants' : tabNumber === 3 ? 'Shirts' : tabNumber === 4 ? 'Vests' : tabNumber === 5 ? 'Ties' : tabNumber === 7 ? 'Shoes' : tabNumber === 8 ? 'Pocket Square' : 'Jewelry '}
																</h5>
															</div>
															<div className="nk-block-head-content">
																<div className="toggle-wrap nk-block-tools-toggle">
																	<div className="toggle-expand-content">
																		<ul className="nk-block-tools g-3">
																			<li className="nk-block-tools-opt">
																				{
																					profile?.name == "Admin" &&
																					<button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addCoatModal" onClick={() => { settype("Add"); handleModalOpen() }}>
																						<span>
																							{tabNumber === 1 ? 'Add Coats' : tabNumber === 2 ? 'Add Pants' : tabNumber === 3 ? 'Add Shirts' : tabNumber === 4 ? 'Add Vests' : tabNumber === 5 ? 'Add Ties' : tabNumber === 7 ? ' Add Shoes' : tabNumber === 8 ? ' Add Pocket Square' : 'Add Jewelry '}
																						</span>
																					</button>
																				}

																			</li>
																		</ul>
																	</div>
																</div>
															</div>
														</div>
													</div>

													{renderTable()}
												</div>
											))}
										</div>
									</div>
									{
										inventory.length > 0 &&

										<div className="nk-block-between-md g-3 mt-3">
											<div className="g">
												<div className="pagination d-flex gap-2" style={{ height: "35px" }}>
													<button
														className={`btn btn-sm ${currentPage === 1 ? 'btn-disabled' : 'btn-primary'}`}
														onClick={() => handlePageChange(currentPage - 1)}
														disabled={currentPage === 1}
													>
														Previous
													</button>

													{Array.from({ length: Math.ceil(totalItems / itemsPerPage) }, (_, i) => (
														<button
															key={i + 1}
															className={`btn btn-sm ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-primary'}`}
															onClick={() => handlePageChange(i + 1)}
														>
															{i + 1}
														</button>
													)).slice(Math.max(0, currentPage - 3), Math.min(currentPage + 2, Math.ceil(totalItems / itemsPerPage)))}

													<button
														className={`btn btn-sm ${currentPage === Math.ceil(totalItems / itemsPerPage) ? 'btn-disabled' : 'btn-primary'}`}
														onClick={() => handlePageChange(currentPage + 1)}
														disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}
													>
														Next
													</button>
												</div>
											</div>
											{
												totalItems > 20 &&
												<div className="g">
													<div className="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
														<div>Showing</div>
														<div>
															<select
																className="form-select js-select2"
																value={itemsPerPage}
																onChange={handleItemsPerPageChange}
															>
																{totalItems >= 10 && <option value="10">10</option>}
																{totalItems >= 20 && <option value="20">20</option>}
																{totalItems >= 50 && <option value="50">50</option>}
																{totalItems >= 100 && <option value="100">100</option>}
															</select>
														</div>
														<div>of {totalItems} items</div>
													</div>
												</div>
											}

										</div>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="modal fade" tabIndex="-1" id="addCoatModal" data-bs-backdrop="static" data-bs-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">
								{type}{tab === 1 ? " Coat" : tab === 2 ? " Pant" : tab === 3 ? " Shirt" : tab === 4 ? " Vests" : tab === 5 ? " Ties" : tab === 7 ? ' Shoes' : tab === 8 ? ' Pocket Square' : ' Jewelry '}
							</h5>
							<a className="close" data-bs-dismiss="modal" aria-label="Close" ref={ref1} style={{ cursor: "pointer" }} onClick={() => { formik.resetForm(); setSelectedImage(null); handleModalClose() }}>
								<em className="icon ni ni-cross-c"></em>
							</a>
						</div>
						<div className="modal-body inputCardBox">
							<form onSubmit={formik.handleSubmit}>
								<div className="row">
									<div className="col-md-4 mb-3">
										<label>Style *</label>
										<input
											type="text"
											className={`form-control ${formik.touched.style && formik.errors.style ? 'is-invalid' : ''}`}
											placeholder="Enter style"
											{...formik.getFieldProps('style')}
										/>
										{formik.touched.style && formik.errors.style ? (
											<div className="invalid-feedback">{formik.errors.style}</div>
										) : null}
									</div>

									{/* Coat Color Field (only for coats - tab 1) */}
									{tab === 1 && (
										<div className="col-md-4 mb-3">
											<label>Coat Color *</label>
											<input
												type="text"
												className={`form-control ${formik.touched.coatColor && formik.errors.coatColor ? 'is-invalid' : ''}`}
												placeholder="Enter color"
												{...formik.getFieldProps('coatColor')}
											/>
											{formik.touched.coatColor && formik.errors.coatColor ? (
												<div className="invalid-feedback">{formik.errors.coatColor}</div>
											) : null}
										</div>
									)}

									{tab === 3 && (
										<div className="col-md-4 mb-3">
											<label>Shirt Type *</label>
											<select
												className={`form-control ${formik.touched.shirtType && formik.errors.shirtType ? 'is-invalid' : ''}`}
												{...formik.getFieldProps('shirtType')}
											>
												<option value="">Select Shirt Type</option>

												{shirtTypes.map((val) => (
													<option key={val} value={val}>{val}</option>
												))}
											</select>
											{formik.touched.shirtType && formik.errors.shirtType && (
												<div className="invalid-feedback">{formik.errors.shirtType}</div>
											)}
										</div>
									)}
									{tab === 4 && (
										<div className="col-md-4 mb-3">
											<label>Vest Type *</label>
											<select
												className={`form-control ${formik.touched.vestType && formik.errors.vestType ? 'is-invalid' : ''}`}
												{...formik.getFieldProps('vestType')}
											>
												<option value="">Select type</option>
												{vestTypes.map((val) => (
													<option key={val} value={val}>{val}</option>
												))}
											</select>
											{formik.touched.vestType && formik.errors.vestType && (
												<div className="invalid-feedback">{formik.errors.vestType}</div>
											)}
										</div>
									)}

									{/* Belt Color Field (only for pants - tab 2) */}
									{tab === 2 && (
										<div className="col-md-4 mb-3">
											<label>Belt Color *</label>
											<select
												className={`form-control ${formik.touched.beltColor && formik.errors.beltColor ? 'is-invalid' : ''}`}
												{...formik.getFieldProps('beltColor')}
											>
												<option value="">Select Belt Color</option>
												{beltColors.map((color) => (
													<option key={color.value} value={color.value}>
														{color.label}
													</option>
												))}
											</select>
											{formik.touched.beltColor && formik.errors.beltColor ? (
												<div className="invalid-feedback">{formik.errors.beltColor}</div>
											) : null}
										</div>
									)}

									{/* Shoe Color Field (only for shoes - tab 7) */}
									{tab === 7 && (
										<div className="col-md-4 mb-3">
											<label>Shoe Color *</label>
											<input
												type="text"
												className={`form-control ${formik.touched.shoeColor && formik.errors.shoeColor ? 'is-invalid' : ''}`}
												placeholder="Enter shoe color"
												{...formik.getFieldProps('shoeColor')}
											/>
											{formik.touched.shoeColor && formik.errors.shoeColor ? (
												<div className="invalid-feedback">{formik.errors.shoeColor}</div>
											) : null}
										</div>
									)}

									<div className="col-md-4 mb-3">
										<label>Active</label>
										<div className="form-control-wrap">
											<div className="form-check form-switch">
												<input
													type="checkbox"
													className={`form-check-input ${formik.touched.active && formik.errors.active ? 'is-invalid' : ''}`}
													id="activeToggle"
													checked={formik.values.active}
													onChange={(e) => {
														formik.setFieldValue('active', e.target.checked);
													}}
													style={{ display: 'none' }}
												/>

												<label
													className="toggle-switch"
													htmlFor="activeToggle"
													style={{
														display: 'inline-block',
														width: '60px',
														height: '34px',
														position: 'relative',
														backgroundColor: formik.values.active ? '#2275FC' : '#ccc',
														borderRadius: '34px',
														cursor: 'pointer',
														transition: 'background-color 0.3s',
														marginLeft: '-43px',
														marginTop: '6px'
													}}
												>
													<span
														style={{
															position: 'absolute',
															height: '26px',
															width: '26px',
															left: formik.values.active ? '30px' : '4px',
															top: '4px',
															backgroundColor: '#fff',
															borderRadius: '50%',
															transition: 'left 0.3s',
														}}
													></span>
												</label>
												<label className="form-check-label ms-1" htmlFor="activeToggle">
													{formik.values.active ? ' Enable' : ' Disable'}
												</label>
											</div>
											{formik.touched.active && formik.errors.active ? (
												<div className="invalid-feedback">{formik.errors.active}</div>
											) : null}
										</div>
									</div>

									{tab === 1 && (
										<div className="col-md-12 mb-3">
											<label>Matching Pant Style</label>
											<select
												className={`form-control ${formik.touched.matchingPantStyle && formik.errors.matchingPantStyle ? 'is-invalid' : ''}`}
												{...formik.getFieldProps('matchingPantStyle')}
											>
												<option value="">Select Matching Pant Style</option>
												{Pant.map((pant) => (
													<option key={pant.id} value={pant.style}>
														{pant.style} - {pant.description}
													</option>
												))}
											</select>
											{formik.touched.matchingPantStyle && formik.errors.matchingPantStyle ? (
												<div className="invalid-feedback">{formik.errors.matchingPantStyle}</div>
											) : null}
										</div>
									)}

									<div className="col-md-12 mb-3">
										<label>Description</label>
										<input
											type="text"
											className={`form-control ${formik.touched.description && formik.errors.description ? 'is-invalid' : ''}`}
											placeholder="Enter description"
											{...formik.getFieldProps('description')}
										/>
										{formik.touched.description && formik.errors.description ? (
											<div className="invalid-feedback">{formik.errors.description}</div>
										) : null}
									</div>

									<div className="col-md-12">
										<div >
											<label >Upload {tab === 1 ? " Coat" : tab === 2 ? " Pant" : tab === 3 ? " Shirt" : tab === 4 ? " Vests" : tab === 5 ? " Ties" : tab === 6 ? " Pocket Square" : tab === 7 ? " Shoes" : "Unknown Tab"} Image</label>
											<input
												type="file"
												id="coatImage"
												name="coatImage"
												ref={fileInputRef}
												className={`form-control ${formik.touched.coatImage && formik.errors.coatImage ? 'is-invalid' : ''}`}
												style={{ padding: "15px 29px" }}
												accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
												onChange={(event) => {
													const file = event.currentTarget.files[0];
													if (file) {
														// Check if the file is an image
														if (!file.type.startsWith('image/')) {
															alert('Please select an image file (JPEG, PNG, GIF, etc.)');
															event.target.value = ''; // Clear the file input
															return;
														}

														setSelectedImage(URL.createObjectURL(file));
														formik.setFieldValue('coatImage', file);
													}
												}}
											/>
											{formik.touched.coatImage && formik.errors.coatImage ? (
												<div className="invalid-feedback">{formik.errors.coatImage}</div>
											) : null}

											{selectedImage && (
												<>
													<div style={{ marginTop: '10px', position: 'relative', display: 'inline-block' }}>
														<img
															src={selectedImage}
															alt=""
															style={{ width: '80px', height: '100px' }}
														/>
														<button
															type="button"
															onClick={() => {
																setSelectedImage(null);
																formik.setFieldValue('coatImage', null);
																if (fileInputRef.current) {
																	fileInputRef.current.value = '';
																}
															}}
															style={{
																position: 'absolute',
																top: '-8px',
																right: '-8px',
																background: '#ff4444',
																color: 'white',
																border: 'none',
																borderRadius: '50%',
																width: '20px',
																height: '20px',
																fontSize: '12px',
																cursor: 'pointer',
																display: 'flex',
																alignItems: 'center',
																justifyContent: 'center',
																zIndex: 1000,
																boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
															}}
															title="Remove image"
														>
															×
														</button>
													</div>
												</>
											)}
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-md-4 mb-3">
										<button type="submit" className="addBtnCustomer" style={isSubmitting ? { pointerEvents: "none" } : {}}>
											{isSubmitting ? (
												<>
													<span className="spinner"></span> Save
												</>
											) : (
												"Save"
											)}
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</Container>
	)
}

export default Inventory